import React from "react";
import { Outlet } from "react-router-dom";

import { Box, useTheme } from "@mui/material";

import Header from "./Header";
import Sidebar from "./Sidebar";

const CollapsedSidebarLayout = () => {
  const theme = useTheme();

  return (
    <>
      <Box
        sx={{
          flex: 1,
          height: "100%",

          ".Mui-FixedWrapper": {
            ".MuiDrawer-root.MuiDrawer-docked": {
              ".MuiPaper-root": {
                left: 108,
              },
            },
          },
        }}
      >
        <Header />
        <Sidebar />
        <Box
          sx={{
            position: "relative",
            zIndex: 5,
            display: "block",
            flex: 1,
            pt: theme.header.height,
            [theme.breakpoints.up("md")]: {
              ml: "200px",
              pt: 0,
            },
            [theme.breakpoints.up("lg")]: {
              px: 2,
            },
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </>
  );
};

export default CollapsedSidebarLayout;
